// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__oTkdv","colCheckbox":"styles_colCheckbox__3jLNh"};